import * as React from 'react';

import { ViewTracker, ViewTrackerContext } from './view-tracker-context';

export interface ViewTrackerProviderProps {
  viewTracker: ViewTracker;
}

export const ViewTrackerContextProvider: React.FC<ViewTrackerProviderProps> = ({ children, viewTracker }) => (
  <ViewTrackerContext.Provider value={viewTracker}>{children}</ViewTrackerContext.Provider>
);
